// extracted by mini-css-extract-plugin
export default {"navbar":"NavMain_navbar__ll+s+","allBoxes":"NavMain_allBoxes__XwNE7","boxliNav":"NavMain_boxliNav__GYNej"};